
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Auth = namespace("Auth");

@Component({
  name: "PainelMenu",
})
export default class PainelMenu extends Vue {
  items = [
    {
      title: "Pedidos",
      url: "pedidos",
      icon: "mdi-file-document-outline",
    },
    {
      title: "Produtos",
      url: "produtos",
      icon: "mdi-package-variant-closed",
    },
    {
      title: "Grupo de Produtos",
      url: "grupos_produtos",
      icon: "mdi-select-group",
    },
    {
      title: "Perfil",
      url: "perfil_usuarios",
      icon: "mdi-account-group",
    },
    {
      title: "Usuários",
      url: "usuarios",
      icon: "mdi-account-supervisor",
    },
    {
      title: "Configurações",
      icon: "mdi-cog",
      subitems: [
        {
          title: "Gerais",
          url: "gerais",
        },
        {
          title: "Comercial",
          url: "comercial",
        },
        {
          title: "Estoque",
          url: "estoque",
        },
        {
          title: "Financeiro",
          url: "financeiro",
        },
        {
          title: "Logística",
          url: "logistica",
        },
      ],
    },
  ];
  
  showSecondList = false;
  drawerstate = false;

  @Auth.Getter
  private isUserAdmin!: boolean;

  beforeMount() {
    if (!this.isUserAdmin) {
      this.$router.push("/");
    }
    this.drawerstate = !this.mobileBreakpoint;
  }

  onPainelItemClick(item: any) {
    this.$router.push(`/administrar/${item.url}`);
    this.drawerstate = false;
  }

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  @Watch("mobileBreakpoint")
  onMobileBreakpointChange(newValue: boolean) {
    if (newValue) {
      this.drawerstate = false;
    } else {
      this.drawerstate = true;
    }
  }

  openPanel() {
    this.drawerstate = true;
  }

  @Watch("drawerstate")
  onPanelChange(e: any) {
    console.log("painel", e);
  }

  onClickOutsidePanel(e) {
    if (e.target.className?.includes("v-btn")) return;
    if (this.drawerstate) {
      this.drawerstate = false;
    }
  }
}
